import React from 'react';
// import baby from '../../../images/baby.png';
import baby from '../../../images/doc/doctor chair 2.jpg';


const FeaturedService = () => {
    return (
        <div className="feature-service pb-0 pb-md-5 pt-md-5">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-md-5 col-sm-6 col-12">
                        <img src={baby} className="img-fluid" alt="" />
                    </div>
                    <div className="col-md-7 col-sm-6 col-12 align-self-center">
                        <h1>Exceptional Dental Care, on your Term</h1>
                        <p className="my-5"
                            style={{
                                color: "#9B9B9B",
                            }}
                        >At our clinic, we prioritize your unique needs and preferences, offering exceptional dental services personalized just for you. Our experienced team of dentists is dedicated to delivering top-quality care using the latest technology and advanced techniques, ensuring your comfort and satisfaction.Experience the difference of exceptional dental care, tailored to your preferences, at "Krishna Dental India". Let us partner with you on your journey to a healthier, brighter smile. Schedule your appointment today and embark on a dental experience like no other!</p>
                        <button className="btn btn-primary"
                            style={{
                                backgroundImage: "linear-gradient(to right,#019CAD, #4880EC )",
                                color: 'white'
                            }}>Learn More</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturedService;